module.exports = __webpack_public_path__ + "static/img/ent-detail-12.124c712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-12.jpg
// module id = bdKt
// module chunks = 51